import Note from '@/modules/Note';
import NoteInfo from '@/modules/NoteInfo';
import NoteUpload from '@/modules/NoteUpload';
import Transcript from '@/modules/Transcript';
import Tabs from '@/components/Tabs';
import { TAB_NAME } from '@/constants/tabs-constants.ts';
import NoteRecording from '@/modules/NoteRecording/NoteRecording.tsx';
import Visits from '@/modules/Visits';
import MainLayout from '@/components/MainLayout';
import CareCues from '@/modules/CareCues';
import {
  navigationSlice,
  selectCurrentSection,
  selectProviderUserSettings,
  selectUnsavedChangesModal,
  useAppDispatch,
  useAppSelector,
} from '@ax/redux-store';
import { NotePageSections } from '@ax/constants';
import { useEffect } from 'react';
import Sidebar from '@/components/Sidebar';
import ConfirmationModal from '@/components/ConfirmationModal';

function Notes() {
  const activeTab = useAppSelector(selectCurrentSection);
  const selectedVisit = useAppSelector((state) => state.selectedVisit);
  const unsavedChangesModal = useAppSelector(selectUnsavedChangesModal);
  const dispatch = useAppDispatch();

  const tabItems = [
    { id: NotePageSections.Transcript, title: TAB_NAME.TRANSCRIPT, component: <Transcript /> },
  ];

  const providerSettings = useAppSelector(selectProviderUserSettings);

  const careCuesEnabled = providerSettings?.enabledNudges;

  if (careCuesEnabled) {
    tabItems.unshift({
      id: NotePageSections.CareCues,
      title: TAB_NAME.CARE_CUES,
      component: <CareCues />,
    });
  }

  useEffect(() => {
    if (providerSettings && activeTab) {
      const isActiveTabAvailable = tabItems.find((tab) => tab.id === activeTab);
      if (!isActiveTabAvailable) {
        // If the active tab is not available, navigate to the first available tab
        dispatch(
          navigationSlice.actions.sectionNavigationRequested({
            section: tabItems[0].id,
            noteId: selectedVisit?.uuid,
          }),
        );
      }
    }
  }, [activeTab, careCuesEnabled, providerSettings, selectedVisit]);

  return (
    <>
      <ConfirmationModal modalOpen={unsavedChangesModal.open} />
      <MainLayout
        sideBarContent={<Sidebar sideBarContent={<Visits />} />}
        mainContent={
          <>
            <div className="flex border-b border-solid border-gray-300">
              <div className="flex flex-grow basis-1/2 justify-between items-center">
                <NoteInfo />
                <NoteRecording />
              </div>
              <div className="flex justify-end basis-1/2">
                <NoteUpload />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
              <div className="border-r border-solid border-gray-300">
                <Tabs
                  activeItem={activeTab}
                  onItemSelect={(section) => {
                    dispatch(
                      navigationSlice.actions.sectionNavigationRequested({
                        section,
                        noteId: selectedVisit?.uuid,
                      }),
                    );
                  }}
                  items={tabItems}
                />
              </div>
              <Note />
            </div>
          </>
        }
      />
    </>
  );
}

export default Notes;
